import { useEffect, useState } from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "./ui/alert-dialog";

let pushRequest = null;

// Drop-in async replacement for window.confirm (which browsers silently block
// inside sandboxed iframes, e.g. the platform preview). Returns Promise<boolean>.
export function appConfirm(opts) {
  const o = typeof opts === "string" ? { description: opts } : opts;
  return new Promise((resolve) => {
    if (pushRequest) pushRequest({ ...o, resolve });
    else resolve(false);
  });
}

export function ConfirmHost() {
  const [req, setReq] = useState(null);
  useEffect(() => {
    pushRequest = setReq;
    return () => { pushRequest = null; };
  }, []);
  const close = (val) => { if (req) req.resolve(val); setReq(null); };
  return (
    <AlertDialog open={!!req} onOpenChange={(o) => { if (!o) close(false); }}>
      <AlertDialogContent data-testid="confirm-dialog" className="z-[200]">
        <AlertDialogHeader>
          <AlertDialogTitle>{req?.title || "Are you sure?"}</AlertDialogTitle>
          {req?.description && (
            <AlertDialogDescription className="whitespace-pre-line">{req.description}</AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-dialog-cancel" onClick={() => close(false)}>Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="confirm-dialog-confirm" onClick={() => close(true)}
            className={req?.destructive ? "bg-[#C0392B] hover:bg-[#A93226]" : "bg-[#12263A] hover:bg-[#1D3A57]"}>
            {req?.confirmLabel || "Confirm"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
